module.exports = __webpack_public_path__ + "img/flower_leaf_2.7d060d67.png";